import type { QuestionArrangement } from "../questions/contracts";
import type { QuestionHost } from "../questions/hosts/shared/types";

export type SurveyLayout = {
  host: QuestionHost;
  arrangement: QuestionArrangement;
};

export const resolveSurveyLayout = (
  orientation: string,
  viewport: { width: number; height: number },
): SurveyLayout => {
  if (orientation === "portrait-land") {
    return { host: "forms", arrangement: "compact" };
  }
  if (orientation === "landscape") {
    return {
      host: "forms",
      arrangement: viewport.width > viewport.height ? "wide" : "compact",
    };
  }
  return { host: "chat", arrangement: "compact" };
};
